module.exports = __webpack_public_path__ + "static/media/LYjMdG_8nE8jDLRUgCZ4rA.1401a287.woff2";